var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":"transparent"},on:{"click":_vm.clicked}},[_c('div',{class:_vm.completed ? 'step-icon-completed' : 'step-icon-open'}),_c('h3',[_vm._v(_vm._s(_vm.stepNr)+". "+_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }